/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerProgramConfigurationDto } from '../models/EntityModelResponseContainerProgramConfigurationDto';
import type { ProgramConfigurationDto } from '../models/ProgramConfigurationDto';
import type { ProgramLockMessagesFormDto } from '../models/ProgramLockMessagesFormDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramConfigurationControllerService {
    /**
     * @returns EntityModelResponseContainerProgramConfigurationDto OK
     * @throws ApiError
     */
    public static reset(): CancelablePromise<EntityModelResponseContainerProgramConfigurationDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/configuration',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramConfigurationDto OK
     * @throws ApiError
     */
    public static readDataForProgramConfigurationPage(): CancelablePromise<EntityModelResponseContainerProgramConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/configuration',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramConfigurationDto OK
     * @throws ApiError
     */
    public static update({
        requestBody,
    }: {
        requestBody: ProgramConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerProgramConfigurationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/configuration',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramConfigurationDto OK
     * @throws ApiError
     */
    public static updateLockMessage({
        requestBody,
    }: {
        requestBody: ProgramLockMessagesFormDto,
    }): CancelablePromise<EntityModelResponseContainerProgramConfigurationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/update_lock_message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
